Wee.fn.make('news', {
	init: function() {
		// Create new instance of grid object with new properties
		var grid = Wee.fn.grid({
			breakpoints: [
				{
					max: 2,
					columns: 1
				},
				{
					size: 3,
					columns: 2
				},
				{
					min: 4,
					columns: 3
				}
			]
		});

		this.grid = grid;
		this.$private.initEvents();
	},

	unload: function() {
		this.grid.destroy();
		$.events.off(false, '.newsFilters');
	}
}, {
	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		Wee.events.on({
			'ref:newsToggle': {
				click: function(e, el) {
					$(el).next().isDisabled() ? scope.enableDropdown(el) : scope.disableDropdown(el);
					e.stopPropagation();
				}
			},
			'body': {
				click: function() {
					$('ref:newsList').disable();
					$('ref:newsFilter').deactivate();
				}
			},
			'ref:newsSort': {
				click: function(e, el) {
					var optionValue = $(el).attr('data-value');

					$.history.go({
						path: Wee.routes.uri().path + '?order=' + optionValue
					});
				}
			}
		},
		{
			namespace: 'newsFilters'
		});
	},

	/**
	 * Enable News Category dropdown
	 *
	 * @private
	 */
	enableDropdown: function(el) {
		var $el = $(el);

		$el.closest('ref:newsFilter').activate();
		$el.next('ref:newsList').enable();
		$el.activate().attr('aria-hidden', false);
	},

	/**
	 * Disable News Category dropdown
	 *
	 * @private
	 */
	disableDropdown: function(el) {
		var $el = $(el);

		$el.closest('ref:newsFilter').deactivate();
		$el.next('ref:newsList').disable();
		$el.deactivate().attr('aria-hidden', true);
	}
});